<template>
  <div class="px-6 pt-4">
    <h1 class="mb-4">{{ $t('CONTENT.contract.card_data_creation') }}</h1>
    <div class="b-create-agreement-card__questions-wrap">
      <div class="mb-5 b-create-agreement-card__question">
        <div
          class="mb-3 b-create-agreement-card__question-title"
        >1. {{ $t('CONTENT.questions.isNotRentContractQuestion') }}
        </div>
        <div class="b-create-agreement-card__question-variants">
          <button
            class="b-btn"
            :class="alternativeKinds.isNotRentContract ? 'b-btn_type_active' : ''"
            data-cy="is-first-question-true"
            @click="clickedRentContract(true)"
          >{{ $t('CONTENT.yes') }}
          </button>
          <button
            class="b-btn"
            :class="!alternativeKinds.isNotRentContract ? 'b-btn_type_active' : ''"
            data-cy="is-first-question-false"
            @click="clickedRentContract(false)"
          >{{ $t('CONTENT.no') }}
          </button>
        </div>
      </div>
      <div class="mb-5 b-create-agreement-card__question">
        <div
          class="mb-3 b-create-agreement-card__question-title"
        >2. {{ $t('CONTENT.questions.isExceptionToArticle3OfIFRS16Question') }}
        </div>
        <div class="b-create-agreement-card__question-variants">
          <button
            class="b-btn"
            :class="alternativeKinds.isExceptionToArticle3OfIFRS16 ? 'b-btn_type_active' : ''"
            data-cy="is-second-question-true"
            @click="alternativeKinds.isExceptionToArticle3OfIFRS16 = true"
            :disabled="alternativeKinds.isNotRentContract === false"
          >{{ $t('CONTENT.yes') }}
          </button>
          <button
            class="b-btn"
            :class="!alternativeKinds.isExceptionToArticle3OfIFRS16 ? 'b-btn_type_active' : ''"
            data-cy="is-second-question-false"
            @click="alternativeKinds.isExceptionToArticle3OfIFRS16 = false"
            :disabled="alternativeKinds.isNotRentContract === false"
          >{{ $t('CONTENT.no') }}
          </button>
        </div>
      </div>
      <div class="mb-5 b-create-agreement-card__question">
        <div
          class="mb-3 b-create-agreement-card__question-title"
        >3. {{ $t('CONTENT.questions.isIrrelevantQuestion') }}
        </div>
        <div class="b-create-agreement-card__question-variants">
          <button
            class="b-btn"
            :class="alternativeKinds.isIrrelevant ? 'b-btn_type_active' : ''"
            data-cy="is-third-question-true"
            @click="alternativeKinds.isIrrelevant = true"
            :disabled="alternativeKinds.isNotRentContract === false"
          >{{ $t('CONTENT.yes') }}
          </button>
          <button
            class="b-btn"
            :class="!alternativeKinds.isIrrelevant ? 'b-btn_type_active' : ''"
            data-cy="is-third-question-false"
            @click="alternativeKinds.isIrrelevant = false"
            :disabled="alternativeKinds.isNotRentContract === false"
          >{{ $t('CONTENT.no') }}
          </button>
        </div>
      </div>
      <div class="mb-5 b-create-agreement-card__question">
        <div class="mb-3 b-create-agreement-card__question-title">
          4. {{ $t('CONTENT.questions.isShortTermQuestion') }}
        </div>
        <div class="b-create-agreement-card__question-variants">
          <button
            class="b-btn"
            :class="alternativeKinds.isShortTerm ? 'b-btn_type_active' : ''"
            data-cy="is-fourth-question-true"
            @click="alternativeKinds.isShortTerm = true"
            :disabled="alternativeKinds.isNotRentContract === false"
          >{{ $t('CONTENT.yes') }}
          </button>
          <button
            class="b-btn"
            :class="!alternativeKinds.isShortTerm ? 'b-btn_type_active' : ''"
            data-cy="is-fourth-question-false"
            @click="alternativeKinds.isShortTerm = false"
            :disabled="alternativeKinds.isNotRentContract === false"
          >{{ $t('CONTENT.no') }}
          </button>
        </div>
      </div>
      <div class="mb-5 b-create-agreement-card__question">
        <div class="mb-3 b-create-agreement-card__question-title">
          5. {{ $t('CONTENT.questions.isLowValue') }}
        </div>
        <div class="b-create-agreement-card__question-variants">
          <button
            class="b-btn"
            :class="alternativeKinds.isLowValue ? 'b-btn_type_active' : ''"
            data-cy="is-fourth-question-true"
            @click="alternativeKinds.isLowValue = true"
            :disabled="alternativeKinds.isNotRentContract === false"
          >{{ $t('CONTENT.yes') }}
          </button>
          <button
            class="b-btn"
            :class="!alternativeKinds.isLowValue ? 'b-btn_type_active' : ''"
            data-cy="is-fourth-question-false"
            @click="alternativeKinds.isLowValue = false"
            :disabled="alternativeKinds.isNotRentContract === false"
          >{{ $t('CONTENT.no') }}
          </button>
        </div>
      </div>
      <div class="mb-5 b-create-agreement-card__question">
        <div class="mb-3 b-create-agreement-card__question-title">
          6. {{ $t('CONTENT.questions.isVariableLeasePayments') }}
        </div>
        <div class="b-create-agreement-card__question-variants">
          <button
            class="b-btn"
            :class="alternativeKinds.isVariableLeasePayments ? 'b-btn_type_active' : ''"
            data-cy="is-fourth-question-true"
            @click="alternativeKinds.isVariableLeasePayments = true"
            :disabled="alternativeKinds.isNotRentContract === false"
          >{{ $t('CONTENT.yes') }}
          </button>
          <button
            class="b-btn"
            :class="!alternativeKinds.isVariableLeasePayments ? 'b-btn_type_active' : ''"
            data-cy="is-fourth-question-false"
            @click="alternativeKinds.isVariableLeasePayments = false"
            :disabled="alternativeKinds.isNotRentContract === false"
          >{{ $t('CONTENT.no') }}
          </button>
        </div>
      </div>
    </div>
    <div class="my-8 pt-6 b-create__button-wrap">
      <button
        class="b-btn b-btn_type_primary mr-4"
        data-cy="set-next-step"
        @click="setNextStep"
      >{{ $t('CONTENT.next') }}
      </button>
      <button
        class="b-btn b-btn_type_empty"
        data-cy="set-next-step"
        @click="$router.push({name: 'Contracts'})"
      >{{ $t('CONTENT.cancel') }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      alternativeKinds: {
        isNotRentContract: true,
        isExceptionToArticle3OfIFRS16: true,
        isIrrelevant: true,
        isShortTerm: true,
        isLowValue: true,
        isVariableLeasePayments: true
      }
    };
  },
  methods: {
    setNextStep() {
      let result = true;

      for (let i in this.alternativeKinds) {
        let transformedAlternativeKinds = {
          isNotRentContract: !this.alternativeKinds.isNotRentContract,
          isExceptionToArticle3OfIFRS16: !this.alternativeKinds.isExceptionToArticle3OfIFRS16,
          isIrrelevant: !this.alternativeKinds.isIrrelevant,
          isShortTerm: !this.alternativeKinds.isShortTerm,
          isLowValue: !this.alternativeKinds.isLowValue,
          isVariableLeasePayments: !this.alternativeKinds.isVariableLeasePayments
        };
        if (this.alternativeKinds[i] === false) {
          result = false;
          this.$store.commit("SET_ALTERNATIVE_KINDS", transformedAlternativeKinds);
          this.$router.push({name: "AlternativeContractCreate"});
          break;
        }
      }
      if (result) {
        this.$router.push({name: "ContractCreate"});
      }
    },

    clickedRentContract(rentContractValue) {
      if (rentContractValue) {
        this.alternativeKinds.isNotRentContract = true;
      } else {
        this.alternativeKinds.isNotRentContract = false;
        this.alternativeKinds.isExceptionToArticle3OfIFRS16 = true;
        this.alternativeKinds.isIrrelevant = true;
        this.alternativeKinds.isShortTerm = true;
        this.alternativeKinds.isLowValue = true;
        this.alternativeKinds.isVariableLeasePayments = true;
      }
    }
  }
};
</script>
